module.exports = __webpack_public_path__ + "static/media/background07.71f8839b.jpg";